import React from "react";
import { DndContext, TouchSensor, MouseSensor, useSensor, useSensors } from "@dnd-kit/core";
import { CanvasItem } from "./CanvasItem";

export default function CanvasDisplay({
  elements,
  canvasRef,
  canvasStyle,
  selectedId,
  onSelect,
  onResize,
  onDragEnd,
  onCanvasPointerDown,
  isEditable = false,
}) {
  
  // 1. Configure Sensors for Mobile
  // This ensures that a touch must be held for a moment (250ms) or moved 
  // significantly before it blocks scrolling.
  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,      // Press and hold to drag
        tolerance: 5,    // Movement tolerance before dragging kicks in
      },
    })
  );

  // 2. Mobile-optimized Styles
  const combinedStyle = {
    ...canvasStyle,
    position: "relative",
    // 'pan-y' allows vertical scrolling even if the thumb starts on a canvas element
    touchAction: isEditable ? "none" : "pan-y", 
    WebkitOverflowScrolling: "touch", // Smooth momentum scroll for iOS
  };

  return (
    <div
      ref={canvasRef}
      style={combinedStyle}
      onPointerDown={onCanvasPointerDown}
    >
      {isEditable ? (
        <DndContext 
          sensors={sensors} // Pass the optimized sensors here
          onDragEnd={onDragEnd} 
          autoScroll={true}
        >
          {elements.map((el) => (
            <CanvasItem
              key={el.id}
              element={{
                ...el,
                isSelected: selectedId === el.id,
                onSelect: () => onSelect(el.id),
                onResize: ({ x, y, width, height }) => {
                  if (onResize) onResize({ id: el.id, x, y, width, height });
                },
              }}
              isEditable={true}
            />
          ))}
        </DndContext>
      ) : (
        elements.map((el) => (
          <CanvasItem
            key={el.id}
            element={el}
            isEditable={false}
          />
        ))
      )}
    </div>
  );
}